<app-header
	[navbarBrandRouterLink]="['/dashboard']"
	[fixed]="true"
	[navbarBrandFull]="{
		src: 'assets/img/brand/logo.png',
		width: 89,
		height: 25,
		alt: 'Netride'
	}"
	[navbarBrandMinimized]="{
		src: 'assets/img/brand/sygnet.png',
		width: 30,
		height: 30,
		alt: 'Netride'
	}"
	[sidebarToggler]="'lg'"
	[asideMenuToggler]="false"
>
	<ul class="nav navbar-nav ml-auto">
		<li
			class="nav-item dropdown d-flex align-items-center"
			dropdown
			placement="bottom right"
		>
			<span class="mr-2 font-weight-bold text-white username">{{
				username
			}}</span>

			<a
				class="nav-link p-0 cursor-pointer"
				role="button"
				aria-haspopup="true"
				aria-expanded="false"
				dropdownToggle
			>
				<img
					src="assets/img/avatars/9.png"
					class="img-avatar border-avatar"
					alt="admin@bootstrapmaster.com"
				/>
			</a>

			<div
				class="dropdown-menu dropdown-menu-right"
				*dropdownMenu
				aria-labelledby="simple-dropdown"
			>
				<button class="dropdown-item" (click)="logout()">
					<i class="fa fa-lock"></i> Logout
				</button>
				<button class="dropdown-item" (click)="goProfile()">
					<i class="fa fa-lock"></i> Ver perfil
				</button>
			</div>
		</li>
	</ul>
</app-header>
<div class="app-body">
	<app-sidebar
		#appSidebar
		[fixed]="true"
		[display]="'lg'"
		[minimized]="sidebarMinimized"
		(minimizedChange)="toggleMinimize($event)"
	>
		<app-sidebar-nav
			[navItems]="navItems"
			[perfectScrollbar]
			[disabled]="appSidebar.minimized"
		></app-sidebar-nav>
		<app-sidebar-minimizer></app-sidebar-minimizer>
	</app-sidebar>
	<!-- Main content -->
	<main class="main">
		<!-- Breadcrumb -->
		<!-- breaking change 'cui-breadcrumb' -->
		<cui-breadcrumb>
			<!-- Breadcrumb Menu-->
			<!--<li class="breadcrumb-menu d-md-down-none">
        <div class="btn-group" role="group" aria-label="Button group with nested dropdown">
          <a class="btn" href="#"><i class="icon-speech"></i></a>
          <a class="btn" [routerLink]="['/dashboard']"><i class="icon-graph"></i> &nbsp;Dashboard</a>
          <a class="btn" href="#"><i class="icon-settings"></i> &nbsp;Settings</a>
        </div>
      </li>-->
		</cui-breadcrumb>
		<!-- deprecation warning for 'app-breadcrumb' -->
		<!--<ol class="breadcrumb">-->
		<!--<app-breadcrumb></app-breadcrumb>-->
		<!--&lt;!&ndash; Breadcrumb Menu&ndash;&gt;-->
		<!--<li class="breadcrumb-menu d-md-down-none">-->
		<!--<div class="btn-group" role="group" aria-label="Button group with nested dropdown">-->
		<!--<a class="btn" href="#"><i class="icon-speech"></i></a>-->
		<!--<a class="btn" [routerLink]="['/dashboard']"><i class="icon-graph"></i> &nbsp;Dashboard</a>-->
		<!--<a class="btn" href="#"><i class="icon-settings"></i> &nbsp;Settings</a>-->
		<!--</div>-->
		<!--</li>-->
		<!--</ol>-->
		<div class="container-fluid">
			<router-outlet></router-outlet>
		</div>
		<!-- /.container-fluid -->
	</main>
</div>
<app-footer>
	<span>NetRide &copy; 2020 daleicocorp.</span>
</app-footer>
